<template>
    <div class="cloudPan">
        <div class="cargoDataBox">
            <el-table :data="[cargoData]" class="cargoData">
                <el-table-column prop="productName"
                                 label="产品名称">
                </el-table-column>
                <el-table-column prop="drCode"
                                 label="主提单号">
                </el-table-column>
                <el-table-column prop="startPort"
                                 label="始发港">
                </el-table-column>
                <el-table-column prop="endPort"
                                 label="目的港">
                </el-table-column>
                <el-table-column prop="shippingDate"
                                 label="开航日期">
                </el-table-column>
                <el-table-column prop="flightCode"
                                 label="航班号">
                </el-table-column>
                <el-table-column prop="intoCabinCode"
                                 label="进仓编号"
                                 width="150px">
                </el-table-column>
                <el-table-column prop="bookingUnitPrice"
                                 label="订舱单价">
                    <template slot-scope="scope">
                        ¥ {{scope.row.bookingUnitPrice}}
                    </template>
                </el-table-column>
            </el-table>
            <div class="bookingData">
                <div class="title">订舱数据</div>
                <div class="row">
                    <div class="item">件数：{{bookingData.pieces}}PCS</div>
                    <div class="item">重量：{{bookingData.weight}}KGS</div>
                    <div class="item">体积：{{bookingData.volume}}CBM</div>
                    <div class="item">比重：1:{{bookingData.proportion}}</div>
                    <div class="item">货型：{{bookingData.bookingPosition === '0' ? '正装' : '备装'}}/{{bookingData.cargoType === '0' ? '散货' : '托盘'}}</div>
                    <div class="item">分泡比例：{{bookingData.bubbleRatio}}</div>
                </div>
            </div>
        </div>
        <div class="operatingRow">
            <div class="operatingBox">
                <div class="uploadDocBox" @click="uploadDoc">
                    <i class="iconfont icon-shangchuanziliao"></i>
                    <span class="text">上传资料</span>
                </div>
                <a :href="`/personalCenter/operationCenter/cargoQuery/exportBusiness/CustomService?orderBillCode=${orderBillCode}`"
                   target="_blank"
                   @click="$bigData('定制服务', '定制服务', orderBillCode)">
                    <div class="customServiceBox">
                        <i class="iconfont icon-dingzhifuwu"></i>
                        <span class="text">定制服务</span>
                    </div>
                </a>
            </div>
            <div class="showMiscellaneousFeeList">
                <span class="text" @click="isShowMiscellaneousFeeListDialog = true; $bigData('查看杂费清单', '查看杂费清单', orderBillCode)">查看杂费清单</span>
            </div>
        </div>
        <div class="docDownload">
            <div class="title">资料下载</div>
            <div class="filesBox">
                <div class="smallTitle">交货文件（模板）</div>
                <div class="fileDownloadType">
                    <el-radio-group v-model="filesDataType"
                                    size="small"
                                    @change="$bigData('交货文件（模板）切换', '交货文件（模板）切换', filesDataType)">
                        <el-radio-button class="goodsTypeRadio" label="0">{{$t('message.generalGoods')}}
                        </el-radio-button>
                        <el-radio-button class="goodsTypeRadio" label="1">{{$t('message.batteryGoods')}}
                        </el-radio-button>
                        <el-radio-button class="goodsTypeRadio" label="2">{{$t('message.chemicalsGoods')}}
                        </el-radio-button>
                    </el-radio-group>
                </div>
                <div class="fileDownloadList">
                    <el-table :data="filesData[filesDataType]"
                              style="width: 1010px;"
                              max-height="350">
                        <el-table-column
                                :label="$t('message.index')"
                                type="index"
                                align="center"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                :label="$t('message.fileName')"
                                property="name"
                                align="center"
                                width="650">
                        </el-table-column>
                        <el-table-column :label="$t('message.option')"
                                         align="center"
                                         width="180">
                            <template slot-scope="scope">
                                <div style="display: flex; justify-content: center;">
                                    <a v-if="scope.row.template"                              
                                       href="javascript:void(0);"                             
                                       class="el-button el-button--mini el-button--success"
                                       @click="$bigData('交货文件（模板）查看', '交货文件（模板）查看', scope.row.name + orderBillCode);isShowCheckYLDialog = true;activeTemplate = scope.row.template">{{$t('message.templateView')}}</a>
                                    <a  style="margin-top: 0; margin-left: 10px;"
                                        :target="scope.row.download ? '_blank' : '_self'"
                                        :href="scope.row.download || 'javascript:void(0);'"
                                        :download="Boolean(scope.row.download) === true ? '' : false"
                                        class="el-button el-button--mini el-button--success"
                                        @click="$bigData('交货文件（模板）点击', '交货文件（模板）点击', scope.row.name + orderBillCode)">{{$t('message.download')}}</a>
                                </div>
                               
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <SJMLoading v-if="filesDataLoading"></SJMLoading>
            </div>
            <div class="filesBox">
                <div class="smallTitle">单证类</div>
                <div class="fileDownloadType BillFile">
                    <el-radio-group v-model="fileDownloadType"
                                    size="small"
                                    @change="$bigData('单证类切换', '单证类切换', fileDownloadType)">
                        <el-radio-button class="goodsTypeRadio" label="0">
                            {{$t('message.customsClearanceClass')}}
                        </el-radio-button>
                        <el-radio-button class="goodsTypeRadio" label="1">{{$t('message.deliveryClass')}}
                        </el-radio-button>
                        <el-radio-button class="goodsTypeRadio" label="2">{{$t('message.waybillClass')}}
                        </el-radio-button>
                        <el-radio-button class="goodsTypeRadio" label="3">
                            {{$t('message.warehousePhotosClass')}}
                        </el-radio-button>
                    </el-radio-group>
                </div>
                <div class="documentsClassDetail">
                    <div class="detailItem">
                        <template v-if="fileDownload[fileDownloadType].length !== 0">
                            <a v-for="(item,index) in fileDownload[fileDownloadType]"
                               :key="index"
                               :href="item.link"
                               target="_blank"
                               :class="{abnormal: item.abnormal === '1'}"
                               @click="$bigData('单证类文件点击', '单证类文件点击', orderBillCode + '+' + item.name)">{{item.name}}</a>
                        </template>
                        <div v-else class="noData">{{$t('message.noData')}}</div>
                    </div>
                </div>
                <SJMLoading v-if="fileDownloadLoading"></SJMLoading>
            </div>
        </div>
        <!-- 主单 查看/确认 Dialog -->
        <el-dialog title=""
                   width="1000px"
                   top="5vh"
                   class="checkMAWBDialog"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   :visible.sync="isShowCheckYLDialog">
            <div class="checkDialogWrap">
                <iframe frameborder="0"
                        :src="activeTemplate"></iframe>
            </div>
    
        </el-dialog>
        <el-dialog title="请填写操作联系方式"
                   :visible.sync="isShowContactDataDialog"
                   width="490px"
                   custom-class="contactDataDialog"
                   :show-close="false"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false">
            <div class="contactDataWrap">
                <el-popover v-model="isShowContactInfo"
                            placement="bottom"
                            width="82"
                            trigger="manual">
                    <div class="contactInfoList">
                        <div v-for="(item, index) in contactInfo"
                             :key="index"
                             class="contactInfoListItem"
                             @click="chooseContact(item)">{{item.name}}
                        </div>
                    </div>
                    <div slot="reference"
                         class="contactInfo"
                         @click="isShowContactInfo = true">历史联系人
                    </div>
                </el-popover>
                <div class="contactInfoBox">
                    <div class="infoItem">
                        <div>
                            <span class="star">*</span>
                            <span>操作联系人：</span>
                        </div>
                        <el-input v-model.trim="contactInfoData.name" class="itemInput"></el-input>
                    </div>
                    <div class="infoItem">
                        <div>
                            <span class="star">*</span>
                            <span>操作联系电话：</span>
                        </div>
                        <el-input v-model.trim="contactInfoData.tel"
                                  class="itemInput"
                                  :maxlength="$maxByteLength('contactInfoData.tel', 20)"></el-input>
                    </div>
                    <div class="infoItem">
                        <div>
                            <span class="star">*</span>
                            <span>操作QQ：</span>
                        </div>
                        <el-input v-model.trim="contactInfoData.qq"
                                  class="itemInput"
                                  :maxlength="$maxByteLength('contactInfoData.qq', 20)"></el-input>
                    </div>
                </div>
                <div class="btnBox">
                    <el-button type="primary"
                               class="btn"
                               @click="postMallOrderCloudPanIndexContactData">保存
                    </el-button>
                </div>
                <SJMLoading v-if="contactDataLoading"></SJMLoading>
            </div>
        </el-dialog>
        <el-dialog title="上传资料"
                   :visible.sync="isShowUploadDocDialog"
                   width="490px"
                   custom-class="uploadDocDialog"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false"
                   @close="closeUploadDocDialog">
            <div class="uploadDocWrap">
                <div class="chooseCustomsServiceMode">
                    <div class="title">选择报关方式</div>
                    <div class="container">
                        <div class="item"
                             :class="{selected: customsClearanceMode === '1', canChange: isSubmit === '0'}"
                             @click="csModeChange('1')">
                            <i class="iconfont icon-pingtaibaoguan"></i>
                            <span>平台报关</span>
                            <div class="circle">
                                <i class="iconfont icon-check"></i>
                            </div>
                        </div>
                        <div class="item"
                             :class="{selected: customsClearanceMode === '0', canChange: isSubmit === '0'}"
                             @click="csModeChange('0')">
                            <i class="iconfont icon-zibaoguan"></i>
                            <span>自报关</span>
                            <div class="circle">
                                <i class="iconfont icon-check"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uploadDocBox">
                    <div v-if="customCompanyName">报关授权信息：{{customAuthorization}}</div>
                    <div class="title">上传资料</div>
                    <div class="container">
                        <div>
                            <div class="item">
                                <i class="iconfont icon-shangchuanziliao"></i>
                                <span>运单类</span>
                                <el-button  type="primary"
                                            class="btn"
                                            @click="uploadClick('005')">上传</el-button>
                            </div>
                            <div class="item" style="margin-top: 20px;">
                                <i class="iconfont icon-shangchuanziliao"></i>
                                <span>分舱单+随机文件</span>
                                <el-button  type="primary"
                                            class="btn"
                                            @click="uploadClick('054')">上传</el-button>
                            </div>
                        </div>                  
                        <div v-if="customsClearanceMode === '1'" 
                             class="item"
                             style="height: auto;">
                            <i class="iconfont icon-shangchuanziliao"></i>
                            <span>报关资料</span>
                            <el-button type="primary"
                                       class="btn"
                                       @click="uploadClick('004')">上传</el-button>
                        </div>
                        <div v-if="customsClearanceMode === '0'"
                             class="item"
                             style="height: auto;">
                            <i class="iconfont icon-shangchuanziliao"></i>
                            <span>放行通知书</span>
                            <el-button type="primary"
                                       class="btn"
                                       @click="uploadClick('048')">上传</el-button>
                        </div>
                    </div>
                </div>
                <div v-if="customsClearanceMode === '1'" class="chooseCustomsServiceType">
                    <div class="title">选择报关类型</div>
                    <div class="container">
                        <el-checkbox :value="customsClearanceType === '1'"
                                     :disabled="isSubmit === '1'"
                                     @change="changeFlag = true;customsClearanceType = '1'; $bigData('报关类型切换', '报关类型切换', orderBillCode + '+' + '正常报关')">正常报关
                        </el-checkbox>
                        <el-checkbox :value="customsClearanceType === '4'"
                                     :disabled="isSubmit === '1'"
                                     @change="changeFlag = true;customsClearanceType = '4'; $bigData('报关类型切换', '报关类型切换', orderBillCode + '+' + '拉联系单')">拉联系单
                        </el-checkbox>
                        <el-checkbox :value="customsClearanceType === '5'"
                                     :disabled="isSubmit === '1'"
                                     @change="changeFlag = true;customsClearanceType = '5'; $bigData('报关类型切换', '报关类型切换', orderBillCode + '+' + '特种报关')">特种报关
                        </el-checkbox>
                        
                        <el-button type="primary"
                                   class="saveBtn"
                                   :disabled="isSubmit === '1' || customsClearanceType === '0'"
                                   @click="postMallOrderCustomsServiceTypeData">保存</el-button>
                    </div>
                </div>               
                <div v-if="customsClearanceType === '4' || customsClearanceType === '1' || customsClearanceType === '5'"
                     style="margin-top: 0; background: #9e9e9e36;" 
                     class="relation-bill">
                    <div class="bill-cloumn1">分单编号</div>
                    <div class="bill-cloumn2">报关件数</div>
                    <div class="bill-cloumn3">报关重量</div>
                    <div class="bill-cloumn4">操作</div>
                    
                </div>
                <template v-if="customsClearanceType === '4'">
                    <div v-for="(v,i) in pullContactListInfo" 
                         :key="i" 
                         class="relation-bill">
                        <div class="bill-cloumn1">
                            <el-input v-model.trim="v.customsHouseCode"
                                      :disabled="isSubmit === '1'"                                     
                                      style="width: 100px;"
                                      @input.native="changeFlag = true"
                            >
                            </el-input>
                        </div>
                        <div class="bill-cloumn2">
                            <el-input v-model.trim="v.customsPieces"                                   
                                      :disabled="isSubmit === '1'"
                                      style="width: 80px;"
                                      @input.native="changeFlag = true"
                            />
                        </div>
                        <div class="bill-cloumn3">
                            <el-input v-model.trim="v.customsWeight"
                                      :disabled="isSubmit === '1'"
                                      style="width: 80px;"
                                      @input.native="changeFlag = true"
                            />
                        </div>
                        <div class="bill-cloumn4" style="display: flex;">
                            <el-button plain
                                       :disabled="isSubmit === '1'"
                                       style="width: 52px;"
                                       @click="pullContactListInfo.push({customsWeight: '',customsPieces: '',customsHouseCode: ''})"
                                      
                            >                        
                                添加
                            </el-button>
                            <el-button plain
                                       :disabled="isSubmit === '1' || pullContactListInfo.length === 1"                          
                                       style="width: 52px; margin-left: 8px;"
                                       @click="deleteClearance(v,i,pullContactListInfo)"
                            >                        
                                删除
                            </el-button>
                        </div>                
                    </div>
                </template>              
                <template v-if="customsClearanceType === '1'">
                    <div v-for="(v,i) in pullContactListInfo1" 
                         :key="i" 
                         class="relation-bill">
                        <div class="bill-cloumn1">
                            <el-input v-model.trim="v.customsHouseCode"
                                      :disabled="isSubmit === '1'"                                     
                                      style="width: 100px;"
                                      @input.native="changeFlag = true"
                            >
                            </el-input>
                        </div>
                        <div class="bill-cloumn2">
                            <el-input v-model.trim="v.customsPieces"
                                      :disabled="isSubmit === '1'"
                                      style="width: 80px;"
                                      @input.native="changeFlag = true"
                            />
                        </div>
                        <div class="bill-cloumn3">
                            <el-input v-model.trim="v.customsWeight"
                                      :disabled="isSubmit === '1'"
                                      style="width: 80px;"
                                      @input.native="changeFlag = true"
                            />
                        </div>
                        <div class="bill-cloumn4" style="display: flex;">
                            <el-button plain
                                       :disabled="isSubmit === '1'"
                                       style="width: 52px;"
                                       @click="pullContactListInfo1.push({customsWeight: '',customsPieces: '',customsHouseCode: ''})"
                                      
                            >                        
                                添加
                            </el-button>
                            <el-button plain
                                       :disabled="isSubmit === '1' || pullContactListInfo1.length === 1"                          
                                       style="width: 52px; margin-left: 8px;"
                                       @click="deleteClearance(v,i,pullContactListInfo1)"
                            >                        
                                删除
                            </el-button>
                        </div>                
                    </div>
                </template>
                <template v-if="customsClearanceType === '5'">
                    <div v-for="(v,i) in pullContactListInfo5" 
                         :key="i" 
                         class="relation-bill">
                        <div class="bill-cloumn1">
                            <el-input v-model.trim="v.customsHouseCode"
                                      :disabled="isSubmit === '1'"                                     
                                      style="width: 100px;"
                                      @input.native="changeFlag = true"
                            >
                            </el-input>
                        </div>
                        <div class="bill-cloumn2">
                            <el-input v-model.trim="v.customsPieces"
                                      :disabled="isSubmit === '1'"
                                      style="width: 80px;"
                                      @input.native="changeFlag = true"
                            />
                        </div>
                        <div class="bill-cloumn3">
                            <el-input v-model.trim="v.customsWeight"
                                      :disabled="isSubmit === '1'"
                                      style="width: 80px;"
                                      @input.native="changeFlag = true"
                            />
                        </div>
                        <div class="bill-cloumn4" style="display: flex;">
                            <el-button plain
                                       :disabled="isSubmit === '1'"
                                       style="width: 52px;"
                                       @click="pullContactListInfo5.push({customsWeight: '',customsPieces: '',customsHouseCode: ''})"
                                      
                            >                        
                                添加
                            </el-button>
                            <el-button plain
                                       :disabled="isSubmit === '1' || pullContactListInfo5.length === 1"                          
                                       style="width: 52px; margin-left: 8px;"
                                       @click="deleteClearance(v,i,pullContactListInfo5)"
                            >                        
                                删除
                            </el-button>
                        </div>                
                    </div>
                </template>
                <div class="btnBox">                
                    <el-tooltip v-if="changeFlag"
                                effect="light"
                                :offset="-160"
                                :visible-arrow="false"
                                popper-class="modifyBorder" 
                                :content="'请先保存'" 
                                placement="top">
                        <div>
                            <el-button  type="primary"
                                        class="btn"
                                        :disabled="isSubmit === '1' || changeFlag"
                                        @click="customsClearanceMode === '0' ? postMallOrderCustomsServiceSelfData() : postMallOrderCustomsServicePlatformData()">
                                {{customsClearanceMode === '0' ? '点击自报完成' : '点击可报关'}}
                            </el-button>
                        </div>
                        
                    </el-tooltip>
                    <el-button  v-if="!changeFlag"
                                type="primary"
                                class="btn"
                                :disabled="isSubmit === '1'"
                                @click="customsClearanceMode === '0' ? postMallOrderCustomsServiceSelfData() : postMallOrderCustomsServicePlatformData()">
                        {{customsClearanceMode === '0' ? '点击自报完成' : '点击可报关'}}
                    </el-button>
                </div>
                <SJMLoading v-if="uploadDocLoading"></SJMLoading>
            </div>
        </el-dialog>
        <el-dialog title="查看杂费清单"
                   :visible.sync="isShowMiscellaneousFeeListDialog"
                   width="490px"
                   custom-class="miscellaneousFeeListDialog"
                   :show-close="!miscellaneousFeeListLoading"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false">
            <div class="miscellaneousFeeListWrap">
                <el-menu :default-active="miscellaneousFeeListKey"
                         mode="horizontal"
                         @select="miscellaneousFeeListSelect">
                    <el-menu-item index="airlinesFeeList">航司类</el-menu-item>
                    <el-menu-item index="ccFeeList">报关类</el-menu-item>
                    <el-menu-item index="warehouseFeeList">仓库类</el-menu-item>
                </el-menu>
                <el-table :data="nowMiscellaneousFeeList">
                    <el-table-column prop="feeName"
                                     label="费用名称">
                    </el-table-column>
                    <el-table-column prop="unitPrice"
                                     label="单价">
                        <template slot-scope="scope">
                            <span>¥ {{scope.row.unitPrice}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="billingMethod"
                                     label="计费方式">
                        <template slot-scope="scope">
                            {{billingMethodList[scope.row.billingMethod]}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark"
                                     label="备注">
                    </el-table-column>
                </el-table>
                <div class="btnBox">
                    <el-button type="primary" @click="isShowMiscellaneousFeeListDialog = false;">确定</el-button>
                </div>
                <SJMLoading v-if="miscellaneousFeeListLoading"></SJMLoading>
            </div>
        </el-dialog>
        <UploadFile :show="isShowUploadFile"
                    type="1"
                    :uploadType="uploadType"
                    :orderBillCode="orderBillCode"
                    @save="uploadSuccess"></UploadFile>
        <SJMLoading v-if="cargoDataLoading"></SJMLoading>
    </div>
</template>

<script>
    // 上传文件组件
    import UploadFile from '@/components/plugin/UploadFile';

    export default {
        name: 'CloudPan',// 云盘
        components: {
            UploadFile
        },
        data() {
            return {
                changeFlag: false,
                orderBillCode: this.$route.query.orderBillCode,// 托单号
                
                miscellaneousFeeListLoading: false,// 杂费清单弹窗 loading
                cargoDataLoading: false,// 货物数据 loading
                filesDataLoading: true,// 交货资料 loading
                fileDownloadLoading: true,// 单证类 loading
                contactDataLoading: false,// 填写操作联系方式 loading
                uploadDocLoading: false,// 上传资料 loading
                isShowContactDataDialog: false,// 是否显示 填写操作联系方式 弹窗
                isShowContactInfo: false,// 是否显示 历史联系人 下拉框
                isShowUploadDocDialog: false,// 是否显示 上传资料 弹窗
                isShowMiscellaneousFeeListDialog: false,// 是否显示 杂费清单 弹窗
                isShowUploadFile: -1,// 显示 文件上传 组件

                // 货物信息
                cargoData: {
                    cargoStationId: '',// 货站id
                    productName: '',// 产品名称
                    drCode: '', // 主提单号
                    startPort: '',// 始发港
                    endPort: '',// 目的港
                    shippingDate: '',// 开航日期
                    flightCode: '',// 航班号
                    intoCabinCode: '',// 进仓编号
                    bookingUnitPrice: '',// 订舱单价
                },
                // 订舱数据
                bookingData: {
                    pieces: '',// 件数（无数据返回空字符串）
                    weight: '',// 重量（无数据返回空字符串）
                    volume: '',// 体积（无数据返回空字符串）
                    proportion: '',// 比重（无数据返回空字符串）
                    bookingPosition: '',// 正备装 0-正装、1-备装
                    cargoType: '',// 货型 0-散货、1-托盘
                    bubbleRatio: '',// 分泡比例（具体比例，如：2/8 || 不分泡）
                },
                contactInfo: [],// 历史联系方式

                // 联系人信息
                contactInfoData: {
                    name: '',// 联系人
                    tel: '',// 电话
                    qq: '',// qq
                },

                filesDataType: '0',// 交货资料 类型 0-普货 1-含锂电池货物 2-一般化工品
                fileDownloadType: '0', // 单证类 类型 0-报关类 1-交货类 2-运单类 3-仓库照片类

                // 交货资料 文件
                filesData: {
                    // 普货
                    0: [],
                    // 含锂电池货物
                    1: [],
                    // 一般化工品
                    2: [],
                },
                // 单证类 文件
                fileDownload: {
                    // 报关类
                    0: [],
                    // 交货类
                    1: [],
                    // 运单类
                    2: [],
                    // 仓库照片类
                    3: []
                },

                customsClearanceMode: '',// 报关方式 0-自报关、1-平台报关
                customCompanyName: '',// 报关行授权公司名
                customAuthorization: '',// 报关行授权信息
                customsClearanceType: '',// 报关类型 0-空、1-正常报关、4-拉联系单、5-特种报关
                isSubmit: '',// 报关提交 0-可报关、1-不可报关
                pullContactListInfo: [{customsWeight: '',customsPieces: '',customsHouseCode: ''}],
                pullContactListInfo5: [{customsWeight: '',customsPieces: '',customsHouseCode: ''}],
                pullContactListInfo1: [{customsWeight: '',customsPieces: '',customsHouseCode: ''}],
                uploadType: '',// 上传的文件类型（内控专用）

                // 杂费清单列表
                miscellaneousFeeList: {
                    // 航司类
                    airlinesFeeList: [],
                    // 报关类
                    ccFeeList: [],
                    // 仓库类
                    warehouseFeeList: [],
                },
                miscellaneousFeeListKey: 'airlinesFeeList',// 当前显示的杂费清单 key
                // 杂费清单 计费方式 列表
                billingMethodList: {
                    0: '托单重量',
                    1: '托单体积',
                    3: '固定数量',
                    4: '计费重量',
                    7: '分单数'
                },
                isShowCheckYLDialog: false,
                activeTemplate: ''
            };
        },
        computed: {
            // 当前显示的杂费清单列表
            nowMiscellaneousFeeList() {
                return this.miscellaneousFeeList[this.miscellaneousFeeListKey];
            }
        },
        async created() {
            // 获取商城订单管理云盘主页的数据
            await this.getMallOrderCloudPanIndexData();
            // 获取交货资料的数据
            this.getDeliveryInfoFilesDataV2();
            // 获取 文件下载数据
            this.getOrderBillFileDownload();
            // 获取商城订单管理杂费清单的数据
            this.getMallOrderMiscellaneousFeeListData();
        },
        methods: {
            deleteClearance(v,i,List) {
                if (v.cusDetailId) {
                    this.$ajax({
                        url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/CloudPanHandler.ashx',
                        data: {
                            act: 'postDelExportPullContactData',// 获取商城订单管理报关数据的数据
                            orderBillCode: this.orderBillCode,// 托单号
                            cusDetailId: v.cusDetailId
                        },
                        success: () => {
                            List.splice(i,1);                        
                        }
                    });
                } else {
                    List.splice(i,1);      
                }
                
            },
            // 杂费清单 类型选择
            miscellaneousFeeListSelect(index) {
                this.miscellaneousFeeListKey = index;
                this.$bigData('杂费清单类型选择', '杂费清单类型选择', index);
            },
            // 选择 联系人
            chooseContact(item) {
                this.contactInfoData = {
                    name: item.name,// 联系人
                    tel: item.tel,// 电话
                    qq: item.qq,// qq
                };
                this.isShowContactInfo = false;
            },
            // 点击上传资料
            uploadDoc() {
                this.isShowUploadDocDialog = true;
                // 获取商城订单管理报关数据的数据
                this.getMallOrderCustomsServiceData();
                this.$bigData('上传资料', '上传资料', this.orderBillCode);
            },
            // 关闭上传资料弹窗
            closeUploadDocDialog() {
                // 获取交货资料的数据
                this.getDeliveryInfoFilesDataV2();
                // 获取 文件下载数据
                this.getOrderBillFileDownload();
            },
            // 报关方式切换
            csModeChange(type) {
                if (this.isSubmit === '1') {
                    return;
                }
                this.customsClearanceMode = type;
                // 提交商城订单管理报关方式的数据
                this.postMallOrderCustomsServiceModeData();
                this.getMallOrderCustomsServiceData();

                let bigMsg = type === '0' ? '自报关' : '平台报关';
                this.$bigData('报关方式', '报关方式', this.orderBillCode + '+' + bigMsg);
            },
            // 点击上传按钮
            uploadClick(uploadType) {
                this.uploadType = uploadType;
                this.isShowUploadFile = Math.random();
                this.$bigData('上传文件', '上传文件', this.orderBillCode + '+' + uploadType);
            },
            // 上传文件成功
            uploadSuccess(saveList) {
                // 提交商城订单管理上传文件保存的数据
                this.postMallOrderUpLoadFileSaveData(saveList);
            },
            // 获取商城订单管理云盘主页的数据
            getMallOrderCloudPanIndexData() {
                return new Promise(resolve => {
                    this.$ajax({
                        url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/CloudPanHandler.ashx',
                        data: {
                            act: 'getMallOrderCloudPanIndexData',// 获取商城订单管理云盘主页的数据
                            orderBillCode: this.orderBillCode,// 托单号
                        },
                        beforeSend: () => {
                            this.cargoDataLoading = true;
                        },
                        success: (res) => {
                            this.cargoData.cargoStationId = res.success.cargoStationId;
                            this.cargoData.productName = res.success.productName;
                            this.cargoData.drCode = res.success.drCode;
                            this.cargoData.startPort = res.success.startPort;
                            this.cargoData.endPort = res.success.endPort;
                            this.cargoData.shippingDate = res.success.shippingDate;
                            this.cargoData.flightCode = res.success.flightCode;
                            this.cargoData.intoCabinCode = res.success.intoCabinCode;
                            this.cargoData.bookingUnitPrice = res.success.bookingUnitPrice;
                            this.bookingData.pieces = res.success.bookingData.pieces;
                            this.bookingData.weight = res.success.bookingData.weight;
                            this.bookingData.volume = res.success.bookingData.volume;
                            this.bookingData.proportion = res.success.bookingData.proportion;
                            this.bookingData.bookingPosition = res.success.bookingData.bookingPosition;
                            this.bookingData.cargoType = res.success.bookingData.cargoType;
                            this.bookingData.bubbleRatio = res.success.bookingData.bubbleRatio;
                            this.contactInfo = res.success.contactInfo;
                            // 没有填写联系人 显示 填写操作联系方式 弹窗
                            if (res.success.isWriteContact === '0') {
                                this.isShowContactDataDialog = true;
                            }
                            this.cargoDataLoading = false;
                            resolve();
                        }
                    });
                });
            },
            // 获取交货资料的数据
            getDeliveryInfoFilesDataV2() {
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    data: {
                        act: 'getDeliveryInfoFilesDataV2',// 获取交货资料的数据
                        cargoStationId: this.cargoData.cargoStationId,// 货站id
                    },
                    beforeSend: () => {
                        this.filesDataLoading = true;
                    },
                    success: (res) => {
                        this.filesData[0] = res.success.generalGoods;
                        this.filesData[1] = res.success.batteryGoods;
                        this.filesData[2] = res.success.chemicalsGoods;
                        this.filesDataLoading = false;
                    }
                });
            },
            // 获取 文件下载数据
            getOrderBillFileDownload() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/ExportMainHandler.ashx',
                    data: {
                        act: 'getOrderBillFileDownload',// 获取 文件下载数据
                        orderBillCode: this.orderBillCode, // 主托单号（主单传值）
                    },
                    beforeSend: () => {
                        this.fileDownloadLoading = true;
                    },
                    success: (res) => {
                        this.fileDownload[0] = res.success.customsClearance;
                        this.fileDownload[1] = res.success.delivery;
                        this.fileDownload[2] = res.success.waybill;
                        this.fileDownload[3] = res.success.warehousePhotos;
                        this.fileDownloadLoading = false;
                    }
                });
            },
            // 获取商城订单管理报关数据的数据
            getMallOrderCustomsServiceData() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/CloudPanHandler.ashx',
                    data: {
                        act: 'getMallOrderCustomsServiceData',// 获取商城订单管理报关数据的数据
                        orderBillCode: this.orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.uploadDocLoading = true;
                    },
                    success: (res) => {
                        this.customsClearanceMode = res.success.customsClearanceMode;
                        this.customCompanyName = res.success.customCompanyName;
                        this.customAuthorization = res.success.customAuthorization;
                        this.customsClearanceType = res.success.customsClearanceType;
                        this.isSubmit = res.success.isSubmit;
                        let pullContactListInfo = res.success.pullContactListInfo || [];
                        
                        if (pullContactListInfo.length === 0) {
                            pullContactListInfo = [{                                                 
                                customsHouseCode: '',// 报关分单号
                                customsPieces: '',// 报关件数
                                customsWeight: '',// 报关重量
                            }];
                        }
                        if (this.customsClearanceType === '1') {
                            this.pullContactListInfo1 = pullContactListInfo;
                        } else if (this.customsClearanceType === '4') {
                            this.pullContactListInfo = pullContactListInfo;
                        } else if (this.customsClearanceType === '5') {
                            this.pullContactListInfo5 = pullContactListInfo;
                        }
                        
                        this.uploadDocLoading = false;
                    }
                });
            },
            // 获取商城订单管理杂费清单的数据
            getMallOrderMiscellaneousFeeListData() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/CloudPanHandler.ashx',
                    data: {
                        act: 'getMallOrderMiscellaneousFeeListData',// 获取商城订单管理杂费清单的数据
                        orderBillCode: this.orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.miscellaneousFeeListLoading = true;
                    },
                    success: (res) => {
                        this.miscellaneousFeeList.airlinesFeeList = res.success.airlinesFeeList;
                        this.miscellaneousFeeList.ccFeeList = res.success.ccFeeList;
                        this.miscellaneousFeeList.warehouseFeeList = res.success.warehouseFeeList;
                        this.miscellaneousFeeListLoading = false;
                    }
                });
            },
            // 提交商城订单管理云盘主页操作联系人的数据
            postMallOrderCloudPanIndexContactData() {
                if (this.contactInfoData.name === '') {
                    this.$Message({
                        msg: '请填写操作联系人！'
                    });
                    return;
                }
                if (this.contactInfoData.tel === '') {
                    this.$Message({
                        msg: '请填写操作联系人电话！'
                    });
                    return;
                }
                if (this.contactInfoData.qq === '') {
                    this.$Message({
                        msg: '请填写操作联系人QQ！'
                    });
                    return;
                }

                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/CloudPanHandler.ashx',
                    data: {
                        act: 'postMallOrderCloudPanIndexContactData',// 提交商城订单管理云盘主页操作联系人的数据
                        orderBillCode: this.orderBillCode,// 托单号
                        name: this.contactInfoData.name,// 联系人
                        tel: this.contactInfoData.tel,// 电话
                        qq: this.contactInfoData.qq,// qq
                    },
                    beforeSend: () => {
                        this.contactDataLoading = true;
                    },
                    success: () => {
                        this.$Message({
                            type: 'success',
                            msg: '保存成功！'
                        });
                        this.isShowContactDataDialog = false;
                    },
                    complete: () => {
                        this.contactDataLoading = false;
                    }
                });
            },
            // 提交商城订单管理报关方式的数据
            postMallOrderCustomsServiceModeData() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/CloudPanHandler.ashx',
                    data: {
                        act: 'postMallOrderCustomsServiceModeData',// 提交商城订单管理报关方式的数据
                        orderBillCode: this.orderBillCode,// 托单号
                        customsClearanceMode: this.customsClearanceMode,// 报关方式 0-自报关、1-平台报关
                    },
                    beforeSend: () => {
                        this.uploadDocLoading = true;
                    },
                    success: () => {
                        this.$Message({
                            type: 'success',
                            msg: '报关方式已切换！'
                        });
                    },
                    complete: () => {
                        this.uploadDocLoading = false;
                    }
                });
            },
            // 提交商城订单管理报关类型的数据
            postMallOrderCustomsServiceTypeData() {              
                let pullContactListInfo = [];
                if (this.customsClearanceType === '4') {
                    for (let i in this.pullContactListInfo) {
                        if (this.pullContactListInfo[i].customsHouseCode === '') {
                            this.$Message({
                                msg: '分单编号不能为空！'
                            });
                            return;
                        } else if (this.pullContactListInfo[i].customsPieces === '') {
                            this.$Message({
                                msg: '报关件数不能为空！'
                            });
                            return;
                        } else if (this.pullContactListInfo[i].customsWeight === '') {
                            this.$Message({
                                msg: '报关重量不能为空！'
                            });
                            return;
                        } 
                    }
                    pullContactListInfo = this.pullContactListInfo;
                } else if (this.customsClearanceType === '1') {
                    let type1 = false;
                    for (let i in this.pullContactListInfo1) {
                        if (this.pullContactListInfo1[i].customsHouseCode !== '') {
                            type1 = true;
                            break;
                        } else if (this.pullContactListInfo1[i].customsPieces !== '') {
                            type1 = true;
                            break;
                        } else if (this.pullContactListInfo1[i].customsWeight !== '') {
                            type1 = true;
                            break;
                        } 
                    }
                    if (type1) {
                        for (let i in this.pullContactListInfo1) {
                            if (this.pullContactListInfo1[i].customsHouseCode === '') {
                                this.$Message({
                                    msg: '分单编号不能为空！'
                                });
                                return;
                            } else if (this.pullContactListInfo1[i].customsPieces === '') {
                                this.$Message({
                                    msg: '报关件数不能为空！'
                                });
                                return;
                            } else if (this.pullContactListInfo1[i].customsWeight === '') {
                                this.$Message({
                                    msg: '报关重量不能为空！'
                                });
                                return;
                            } 
                        }
                        pullContactListInfo = this.pullContactListInfo1;
                    } else {
                        pullContactListInfo = undefined;
                    }
                    
                  
                } else if (this.customsClearanceType === '5') {
                    let type1 = false;
                    for (let i in this.pullContactListInfo5) {
                        if (this.pullContactListInfo5[i].customsHouseCode !== '') {
                            type1 = true;
                            break;
                        } else if (this.pullContactListInfo5[i].customsPieces !== '') {
                            type1 = true;
                            break;
                        } else if (this.pullContactListInfo5[i].customsWeight !== '') {
                            type1 = true;
                            break;
                        } 
                    }
                    if (type1) {
                        for (let i in this.pullContactListInfo5) {
                            if (this.pullContactListInfo5[i].customsHouseCode === '') {
                                this.$Message({
                                    msg: '分单编号不能为空！'
                                });
                                return;
                            } else if (this.pullContactListInfo5[i].customsPieces === '') {
                                this.$Message({
                                    msg: '报关件数不能为空！'
                                });
                                return;
                            } else if (this.pullContactListInfo5[i].customsWeight === '') {
                                this.$Message({
                                    msg: '报关重量不能为空！'
                                });
                                return;
                            } 
                        }
                        pullContactListInfo = this.pullContactListInfo5;  
                    } else {
                        pullContactListInfo = undefined;
                    }
                     
                }
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/CloudPanHandler.ashx',
                    data: {
                        act: 'postMallOrderCustomsServiceTypeData',// 提交商城订单管理报关类型的数据
                        orderBillCode: this.orderBillCode,// 托单号
                        customsClearanceType: this.customsClearanceType,// 报关类型 1-正常报关、4-拉联系单、5-特种报关
                        pullContactListInfo: pullContactListInfo ? JSON.stringify(pullContactListInfo) : undefined// 联系单数据 
                    },
                    beforeSend: () => {
                        this.uploadDocLoading = true;
                    },
                    success: () => {
                        this.changeFlag = false;
                        this.$Message({
                            type: 'success',
                            msg: '报关类型已保存！'
                        });
                        this.getMallOrderCustomsServiceData();
                    },
                    complete: () => {
                        this.uploadDocLoading = false;
                    }
                });
                this.$bigData('报关类型保存', '报关类型保存', this.orderBillCode);
            },
            // 提交商城订单管理上传文件保存的数据
            postMallOrderUpLoadFileSaveData(saveList) {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/CloudPanHandler.ashx',
                    data: {
                        act: 'postMallOrderUpLoadFileSaveData',// 提交商城订单管理上传文件保存的数据
                        orderBillCode: this.orderBillCode,// 托单号
                        fileIdList: JSON.stringify(saveList.map(i => i.id)),// 文件ID列表
                    },
                    beforeSend: () => {
                        this.uploadDocLoading = true;
                    },
                    success: () => {
                        this.$Message({
                            type: 'success',
                            msg: '文件上传成功！'
                        });
                    },
                    complete: () => {
                        this.uploadDocLoading = false;
                    }
                });
            },
            // 提交商城订单管理报关数据（平台报关）的数据
            postMallOrderCustomsServicePlatformData() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/CloudPanHandler.ashx',
                    data: {
                        act: 'postMallOrderCustomsServicePlatformData',// 提交商城订单管理报关数据（平台报关）的数据
                        orderBillCode: this.orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.uploadDocLoading = true;
                    },
                    success: () => {
                        this.$Message({
                            type: 'success',
                            msg: '提交成功！'
                        });
                        this.isShowUploadDocDialog = false;
                    },
                    complete: () => {
                        this.uploadDocLoading = false;
                    }
                });
                this.$bigData('点击可报关', '点击可报关', this.orderBillCode);
            },
            // 提交商城订单管理报关数据（自报关）的数据
            postMallOrderCustomsServiceSelfData() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/CloudPanHandler.ashx',
                    data: {
                        act: 'postMallOrderCustomsServiceSelfData',// 提交商城订单管理报关数据（自报关）的数据
                        orderBillCode: this.orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.uploadDocLoading = true;
                    },
                    success: () => {
                        this.$Message({
                            type: 'success',
                            msg: '提交成功！'
                        });
                        this.isShowUploadDocDialog = false;
                    },
                    complete: () => {
                        this.uploadDocLoading = false;
                    }
                });
                this.$bigData('点击自报完成', '点击自报完成', this.orderBillCode);
            }
        }
    };
</script>

<style lang="scss">
    .el-tooltip__popper.is-light.modifyBorder {
        border: 1px solid #ebeef5 !important;
    }

    .cloudPan {
        position: relative;
        display: flex;
        flex-direction: column;
        min-height: 783px;
        overflow: hidden;
        background-color: #f4f4f4;

        .checkDialogWrap {
            text-align: center;
        }

        iframe {
            width: 90%;
            height: 600px;
            margin-bottom: 30px;
            background-color: #fff;

            &.iframeHide {
                visibility: hidden;
            }
        }

        .relation-bill {
            display: flex;
            width: 420px;
            height: 30px;
            padding-left: 10px;
            margin-bottom: 10px;
            line-height: 30px;
            border-radius: 4px 4px 0 0;

            .bill-cloumn1 {
                width: 120px;
            }

            .bill-cloumn2 {
                width: 100px;
            }

            .bill-cloumn3 {
                width: 100px;
            }

            .bill-cloumn4 {
                width: 110px;
            }
        }

        .relation-bill:nth-last-of-type(2) {
            margin-bottom: 30px;
        }

        .cargoDataBox {
            position: relative;
            box-sizing: border-box;
            padding: 30px 30px 27px;
            margin-bottom: 14px;
            background-color: white;

            .cargoData {
                margin-bottom: 17px;
            }

            .bookingData {
                .title {
                    margin-bottom: 20px;
                    font-size: 18px;
                    color: #00a7f7;
                }

                .row {
                    display: flex;

                    .item {
                        margin-right: 25px;
                        font-size: 16px;
                    }
                }
            }
        }

        .operatingRow {
            padding: 32px 30px;
            margin-bottom: 14px;
            background-color: #fff;

            .operatingBox {
                display: flex;
                justify-content: space-between;

                .uploadDocBox,
                .customServiceBox {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 490px;
                    height: 178px;
                    color: #009fe8;
                    cursor: pointer;
                    border: 1px solid #009fe8;
                    border-radius: 4px;

                    &:hover {
                        color: white;
                        background-color: #009fe8;
                    }

                    .iconfont {
                        margin-right: 20px;
                        font-size: 48px;
                    }

                    .text {
                        font-size: 22px;
                    }
                }
            }

            .showMiscellaneousFeeList {
                margin-top: 10px;
                font-size: 16px;
                color: #009fe8;
                text-align: right;

                .text {
                    cursor: pointer;
                }
            }
        }

        .docDownload {
            position: relative;
            box-sizing: border-box;
            padding: 26px 30px 0;
            background-color: white;

            .title {
                margin-bottom: 15px;
                font-size: 18px;
                color: #00a7f7;
            }

            .filesBox {
                position: relative;
                padding-bottom: 25px;
                margin-bottom: 25px;
                border-bottom: 1px dashed #9b9b9b;

                &:last-child {
                    margin-bottom: 0;
                    border-bottom: 0;
                }

                .smallTitle {
                    margin-bottom: 20px;
                    font-size: 16px;
                    color: #3f3a3a;
                }

                .fileDownloadType {
                    display: flex;
                    align-items: center;
                    margin-bottom: 30px;

                    &.BillFile {
                        margin-bottom: 0;
                    }

                    .goodsType {
                        margin-right: 10px;
                        font-size: 15px;
                    }

                    .goodsTypeRadio {
                        width: 140px;
                    }
                }

                .documentsClassDetail {
                    height: 180px;
                    margin: 5px 0 0 0;
                    overflow-y: auto;

                    .detailItem {
                        display: flex;
                        flex-direction: column;
                        float: left;

                        a {
                            display: block;
                            margin: 9px 0 0 0;
                            font-size: 16px;
                            color: #036eb7;

                            &.abnormal {
                                color: #e73828;
                            }
                        }
                    }

                    .noData {
                        margin: 30px 0;
                        font-size: 16px;
                        text-align: center;
                    }
                }

                .el-button + .el-button {
                    margin-top: 5px;
                    margin-left: 0;
                }
            }
        }
    }

    /deep/ .el-dialog__body {
        padding: 30px;
    }

    .contactDataWrap {
        position: relative;

        .contactInfo {
            position: absolute;
            top: 0;
            right: 0;
            color: #009fe8;
            cursor: pointer;
        }

        .contactInfoBox {
            display: flex;
            flex-direction: column;
            padding-top: 30px;
            margin-bottom: 33px;

            .infoItem {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 12px;

                &:last-child {
                    margin-bottom: 0;
                }

                .star {
                    color: #f01a34;
                }

                .itemInput {
                    width: 320px;
                }
            }
        }

        .btnBox {
            text-align: right;

            .btn {
                width: 106px;
                height: 36px;
            }
        }
    }

    .uploadDocWrap {
        .chooseCustomsServiceMode {
            padding-bottom: 17px;
            margin-bottom: 20px;
            border-bottom: 1px dashed #9b9b9b;

            .title {
                margin-bottom: 20px;
                font-size: 16px;
            }

            .container {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .canChange {
                    &:hover {
                        color: white;
                        background-color: #009fe8;
                        transition: 0.25s;
                    }
                }

                .item {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 198px;
                    height: 64px;
                    color: #009fe8;
                    cursor: pointer;
                    border: 1px solid #009fe8;
                    border-radius: 4px;

                    .icon-pingtaibaoguan,
                    .icon-zibaoguan {
                        margin-right: 6px;
                        font-size: 20px;
                    }

                    .icon-check {
                        display: none;
                        font-size: 12px;
                        color: white;
                    }

                    .circle {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 20px;
                        height: 20px;
                        margin-left: 12px;
                        background-color: white;
                        border: 1px solid #009fe8;
                        border-radius: 50%;
                    }
                }

                .selected {
                    color: white;
                    background-color: #009fe8;

                    .icon-check {
                        display: block;
                        color: #009fe8;
                    }
                }
            }
        }

        .uploadDocBox {
            margin-bottom: 30px;

            .title {
                margin-top: 20px;
                margin-bottom: 20px;
                font-size: 16px;
            }

            .container {
                display: flex;
                // align-items: center;
                justify-content: space-between;

                .item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 198px;
                    height: 90px;
                    padding: 20px 0 15px 0;
                    color: #9b9b9b;
                    border: 1px dashed #9b9b9b;
                    border-radius: 4px;

                    .iconfont {
                        margin-bottom: 10px;
                    }

                    .btn {
                        margin-top: 12px;
                    }
                }
            }
        }

        .chooseCustomsServiceType {
            margin-bottom: 15px;

            .title {
                margin-bottom: 20px;
                font-size: 16px;
            }

            .saveBtn {
                margin-left: 30px;
            }
        }

        .btnBox {
            text-align: right;

            .btn {
                width: 134px;
                height: 36px;
            }
        }
    }

    .miscellaneousFeeListWrap {
        position: relative;

        .btnBox {
            margin-top: 20px;
            text-align: right;
        }
    }

    .contactInfoList {
        height: 200px;
        overflow-y: auto;

        .contactInfoListItem {
            box-sizing: border-box;
            height: 33px;
            padding: 0 40px;
            cursor: pointer;
        }
    }
</style>
